import { render, staticRenderFns } from "./InputItem.vue?vue&type=template&id=70464d19&scoped=true&"
import script from "./InputItem.vue?vue&type=script&lang=js&"
export * from "./InputItem.vue?vue&type=script&lang=js&"
import style0 from "./input-item.scss?vue&type=style&index=0&id=70464d19&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70464d19",
  null
  
)

export default component.exports